import * as constants from '../constants.js';
export function waitForElementByInterval(selector, interval = 100, timeout = constants.mutationObserveTimeout) {
    return new Promise((resolve, reject) => {
        // Time elapsed since we started checking
        let elapsed = 0;
        // Check for the element immediately in case it's already present
        const check = () => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(intervalId);
                resolve(element);
            }
            else if (elapsed >= timeout) {
                clearInterval(intervalId);
                reject(new Error(`Timeout while waiting on element "${selector}" to appear.`));
            }
            elapsed += interval;
        };
        // Start periodically checking for the element
        const intervalId = setInterval(check, interval);
        // Perform an immediate check in case the element is already there
        check();
    });
}
//# sourceMappingURL=waitForElementByInterval.js.map